import {
  Box,
  Heading,
  Text,
  Flex,
  Image,
  Link,
  Button,
} from "@chakra-ui/react";
import React, { useEffect } from "react";
import Typed from "typed.js";
import professional from "../Assets/Professional_Pic.png";
import AOS from "aos";
import "aos/dist/aos.css";
import resume from "../Assets/Resume/Ganesh Kumar-Full Stack Web Developer.pdf";
import { FaGithub, FaLinkedin } from "react-icons/fa";
import { HiOutlineMail } from "react-icons/hi";
import { FiPhoneCall } from "react-icons/fi";
import "../Css/Home.css";

export const Home = () => {
  useEffect(() => {
    AOS.init({ delay: 300 });
  }, []);

  useEffect(() => {
    const typed = new Typed(".text", {
      strings: [
        "Web Developer",
        "MERN Stack Developer",
        "Full Stack Developer",
      ],
      typeSpeed: 100,
      backSpeed: 100,
      backDelay: 1000,
      loop: true,
      showCursor: false,
    });

    return () => {
      typed.destroy();
    };
  }, []);

  const openLink = (url) => {
    window.open(url);
  };
  return (
    <>
      <section>
        <Flex
          flexDirection={{
            base: "column-reverse",
            sm: "column-reverse",
            md: "column-reverse",
            lg: "row",
            xl: "row",
            "2xl": "row",
          }}
          justifyContent={"space-between"}
          alignItems={"center"}
          gap="60px"
          id="home"
          p="50px"
          color={"white"}
          className="design"
          margin={"auto"}
        >
          <Box
            width={{
              base: "100%",
              sm: "100%",
              md: "80%",
              lg: "50%",
              xl: "50%",
              "2xl": "50%",
            }}
          >
            <Box id="home-content">
              <Heading
                mt="10px"
                size="lg"
                as="h3"
                className="head"
                fontFamily={"Raleway"}
              >
                Hello, I am
              </Heading>
              <Heading mt="10px" size="2xl" as="h1" id="user-detail-name">
                Ganesh Kumar
              </Heading>
              <Heading mt="10px" size="lg" as="h3">
                <span className="text"></span>
                <span style={{ color: "#0ef", marginLeft: "3px" }}>|</span>
              </Heading>
              <Text
                fontSize={"18px"}
                mt="10px"
                fontWeight={"bold"}
                textAlign={"left"}
              >
                I am a skilled full-stack web developer, proficient in both
                front-end and back-end technologies, dedicated to creating
                engaging and user-friendly web experience.
              </Text>
              <Box display="flex" justifyContent="space-around">
                <Flex alignItems={"center"}>
                  <Link
                    id="contact-github"
                    href="https://github.com/GaneshGourav"
                    isExternal
                  >
                    <FaGithub className="contact-logo" />
                  </Link>
                  <Link
                    id="contact-linkedin"
                    href="https://www.linkedin.com/in/ganeshofficial/"
                    isExternal
                  >
                    <FaLinkedin
                      style={{ marginLeft: "20px" }}
                      className="contact-logo"
                    />
                  </Link>
                  <Link
                    id="contact-linkedin"
                    href="tel:+919572016410"
                    isExternal
                  >
                    <FiPhoneCall
                      style={{ marginLeft: "20px" }}
                      className="contact-logo"
                    />
                  </Link>
                  <Link
                    id="contact-linkedin"
                    href="mailto:mrganeshofficial8@gmail.com"
                    isExternal
                  >
                    <HiOutlineMail
                      style={{ marginLeft: "20px" }}
                      className="contact-logo"
                    />
                  </Link>
                </Flex>
              </Box>

              <Link
                mt="10px"
                fontWeight="bold"
                borderRadius="5px"
                backgroundImage="linear-gradient(to right, #01b395, #03bd69)"
                id="resume-link-2"
                href={resume}
                download={true}
                target="_blank"
              >
                <Box className="home-icon">
                  <Button
                    mt="10px"
                    id="resume-button-2"
                    background="#0ef"
                    onClick={() =>
                      openLink(
                        "https://drive.google.com/file/d/1hdPKbaB3fPXU0EWigQFGA3yYGAFINpn6/view?usp=drive_link"
                      )
                    }
                    className="home-resume btn-box"
                  >
                    Download Resume
                  </Button>
                </Box>
              </Link>
            </Box>
          </Box>
          <Box
            display={"flex"}
            justifyContent={"center"}
            alignItems={"center"}
            width={{
              base: "100%",
              sm: "100%",
              md: "80%",
              lg: "50%",
              xl: "50%",
              "2xl": "50%",
            }}
          >
            <Image
              id="mypic"
              src={professional}
              className="home-img"
              borderColor={"#0ef"}
              alt="myPic"
              w={{
                base: "100%",
                sm: "100%",
                md: "80%",
                lg: "50%",
                xl: "50%",
                "2xl": "50%",
              }}
              height="1%"
              borderRadius="50%"
              backgroundImage="linear-gradient(#0ef, #cf1515, #2813e2,#13e23c)"
              padding={"4px"}
            />
          </Box>
        </Flex>
      </section>
    </>
  );
};
